import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { isLimitedEditionSelector } from '../../../../../redux/product/product.selectors';
import { Buttons as ButtonsComponent } from './buttons';
const mapStateToProps = createStructuredSelector({
  isLimitedEdition: isLimitedEditionSelector
});
export const Buttons = connect(mapStateToProps)(ButtonsComponent);